import { openDialog } from "@/src/components/dialogs";
import { MultiPickerList } from "@/src/components/multiPicker";
import { Input } from "@/src/components/universalInput";
import { Reference } from "@/src/data/allTypes";
import moment from "moment";
import { useState } from "react";

function ExamDateDialog({
  currentReferences,
  currentDate,
  onDateChange,
  onReferencesChange,
}: {
  currentReferences: Reference[];
  currentDate: string;
  onDateChange: (newValue: string) => void;
  onReferencesChange: (newValue: Reference[]) => void;
}) {
  const [date, setDate] = useState(currentDate);
  const [references, setReferences] = useState(currentReferences);
  return (
    <div className="c1 gap10" >
      <Input
        name="Date de l'examen"
        value={currentDate}
        shouldFocus={true}
        type="datetime"
        onChange={(newValue) => {
          setDate(newValue);
          onDateChange(newValue);
        }}
      ></Input>
      {currentReferences.length > 1 && (
        <MultiPickerList
          queryKey={["multiPickerExamReferences"]}
          enableSearch={false}
          loadItems={async (limit, offset, searchKey, viewType, ids) => {
            return currentReferences;
          }}
          onAddClick={async () => {}}
          getChecboxCardContent={(item) => {
            return (
              <div>
                <div className="bold">{item.name}</div>
              </div>
            );
          }}
          current={references || []}
          onChange={(newValue) => {
            setReferences(newValue.filter((item) => item != undefined));
            onReferencesChange(newValue.filter((item) => item != undefined));
          }}
        ></MultiPickerList>
      )}
    </div>
  );
}

export async function openExamDateDialog({
  currentReferences,
  currentDate,
  onConfirm,
}: {
  currentReferences: Reference[];
  currentDate: string | null | undefined;
  onConfirm: (date: string, references: Reference[]) => void;
}) {
  let date = currentDate || moment().format("YYYY-MM-DD HH:mm:ss");
  currentReferences ||= [];
  let references = currentReferences;

  return await openDialog({
    id: "examDateDialog",
    title: (
      <div style={{ maxWidth: "400px" }}>
        Date de l&apos;examen{" "}
        <span className="normal">
          {currentReferences.length == 1
            ? currentReferences.map((reference) => reference.name).join(", ")
            : ""}
        </span>
      </div>
    ),
    content: (
      <ExamDateDialog
        currentReferences={currentReferences}
        currentDate={date}
        onDateChange={(newValue) => {
          date = newValue;
        }}
        onReferencesChange={(newValue) => {
          references = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      onConfirm(date, references);
    },
  });
}

export default ExamDateDialog;
